export default __webpack_public_path__ + "static/media/risk-rating.259c4968.png";